import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { Injectable } from '@angular/core';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { KYMW4500Model } from '../kymw4500.model';

// レスポンス構造
export interface GetMediumGroupDivResponse {
  MediumGroupDiv: string;
}

/**
 * 媒体グループ区分取得
 *
 * @export GetMediumGroupDivService
 * @class GetMediumGroupDivService
 * @extends {PlessResponderSub}
 */
@Injectable()
export class GetMediumGroupDivService extends PlessJsonResponderSub<GetMediumGroupDivResponse> {
  private mediumType: string;
  private orderCode: string;
  private successFunc: Function;
  private model: KYMW4500Model;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetMediumGroupDivService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        OrderCode: this.orderCode,
        MediumType: this.mediumType,
      },
    });
  }

  /**
   * API呼び出し
   * @param model
   * @param successFunc
   * @memberof GetMediumGroupDivService
   */
  execute(model: KYMW4500Model, successFunc: Function = null): void {
    this.model = model;
    this.orderCode = model.orderCode;
    this.mediumType = model.mediumType;
    this.successFunc = successFunc;
    this.send('getMediumGroupDiv', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetMediumGroupDivService
   */
  success(data: GetMediumGroupDivResponse) {
    this.model.mediumGroupDiv = data.MediumGroupDiv;
    if (this.successFunc) this.successFunc();
  }
}
